<template>
    <div :class="{ 'no-header': !showHeader }" class="layout-default">
        <!--        <SideBar ref="sidebar" />-->

        <TheHeader v-if="showHeader" :key="showHeader" ref="header" class="header">
            <ProductSearch ref="search"
                           :suggest="suggest"
                           :suggest-tag="searchWithKindGroup"
                           class="search"
                           @search="doSearch" />
        </TheHeader>

        <div class="content">
            <slot />
        </div>

        <div class="footer">
            <span class="notice">
                ПАО «Ростелеком» обрабатывает пользовательские данные при работе сайта в соответствии с
                <a href="https://msk.rt.ru/legal"
                   target="_blank">Политикой конфиденциальности</a>.
            </span>
            <span class="notice">
                Вы можете ознакомиться с
                <a href="https://www.company.rt.ru/about/disclosure/index.php#pd"
                   target="_blank">Политикой обработки персональных данных</a>.
            </span>
        </div>

        <CookieAccept />
        <ProcessingPersonalData />
        <InstallCertModal />
    </div>
</template>

<script>
import ProductSearch from '@/common/page_comp/SearchProduct/ProductSearch.vue';
import TheHeader from '@/layouts/common/comp/TheHeader.vue';
import CookieAccept from '@/common/page_comp/PrivacyPolice/CookieAccept.vue';
import ProcessingPersonalData from '@/common/page_comp/PrivacyPolice/ProcessingPersonalData.vue';
import InstallCertModal from '@/common/page_comp/InstallCertModal/InstallCertModal.vue';
import SearchProductMixin from '@/layouts/common/search.product.mixin.js';


export default {
    name: 'Default',
    mixins: [ SearchProductMixin ],
    components: {
        ProductSearch,
        TheHeader,
        InstallCertModal,
        ProcessingPersonalData,
        CookieAccept,
    },
    computed: {
        showHeader() {
            return !this.$route.meta.hideHeader;
        },
    },
    provide() {
        return {
            openFeedback: this.openFeedback,
        };
    },
    methods: {
        openFeedback(data) {
            this.$refs.header.openFeedback(data);
        },
    },
};
</script>

<style lang="scss">
:root {
    --footer-height: 52px;
    --header-height: 64px;
    --min-height-page: calc(100vh - (var(--footer-height) + var(--header-height)));
    --min-height-page-without-header: calc(100vh - var(--footer-height));
}
</style>

<style lang="scss" scoped>
.layout-default {
    .header {
        @import "../common/styles.header.scss";
    }

    .content {
        min-height: var(--min-height-page);
    }

    &.no-header {
        .content {
            min-height: var(--min-height-page-without-header);
        }
    }

    .footer {
        height: var(--footer-height);
        margin-left: var(--sidebar-width);
        background: #FFFFFF;
        box-shadow: inset 0px 1px 1px #E7E8EA;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
        box-sizing: border-box;

        .notice {
            color: var(--input-disabled-color);
            font-size: 12px;
            line-height: 16px;
        }
    }
}
</style>
